import _defineProperty from "@babel/runtime/helpers/defineProperty";
var _ExpGloballyUniqueExpressionIDFactory;
/* eslint-disable */
/**
 * Expression Service
 * An API for Expression services, supporting the Expression Editor and Expression Evaluation
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech) (v6.0.1).
 *
 * Do not edit the class manually.
 */

// InputSpec (yaml) file: /var/jenkins_home/workspace/V4-5-1-global-pipeline-all-web-products-build/webcommons/abweb/openapi/internal/typescript/target/openapi/openapi//abwebinternal/expressionservice.yaml
// Template file: models.mustache (typescript-fetch)

// @ts-ignore noUnusedLocals
import { ExpAdditionalIDPropertiesFactory } from "./ExpAdditionalIDProperties";

/**
 * 
 * @export
 * @interface ExpGloballyUniqueExpressionID
 */

export class ExpGloballyUniqueExpressionIDFactory {}
_ExpGloballyUniqueExpressionIDFactory = ExpGloballyUniqueExpressionIDFactory;
_defineProperty(ExpGloballyUniqueExpressionIDFactory, "FromJSON", function (json) {
  return _ExpGloballyUniqueExpressionIDFactory.FromJSONTyped(json, false);
});
_defineProperty(ExpGloballyUniqueExpressionIDFactory, "FromJSONTyped", function (json, ignoreDiscriminator) {
  if (json === undefined || json === null) {
    return json;
  }
  return {
    'domainID': json['domainID'],
    'expressionID': json['expressionID'],
    'additionalIDProperties': json['additionalIDProperties'] === null || json['additionalIDProperties'] === undefined ? json['additionalIDProperties'] : ExpAdditionalIDPropertiesFactory.FromJSON(json['additionalIDProperties'])
  };
});
_defineProperty(ExpGloballyUniqueExpressionIDFactory, "ToJSON", function (value) {
  return _ExpGloballyUniqueExpressionIDFactory.ToJSONTyped(false, value);
});
_defineProperty(ExpGloballyUniqueExpressionIDFactory, "ToJSONTyped", function (ignoreDiscriminator, value) {
  if (value === undefined) {
    return undefined;
  }
  if (value === null) {
    return null;
  }
  return {
    'domainID': value.domainID,
    'expressionID': value.expressionID,
    'additionalIDProperties': ExpAdditionalIDPropertiesFactory.ToJSON(value.additionalIDProperties)
  };
});
//# sourceMappingURL=ExpGloballyUniqueExpressionID.js.map
